import { Shield } from 'lucide-react';
import environment from '@config/environment';
import { DASHBOARD_ROUTES } from './DashboardLayout.constant';
import { DashboardLayoutNavItem } from './DashboardLayoutNavItem';
import { BottomNavBar, BottomNavItem } from '@design-system/BottomNavBar';
import { usePeacockAcl } from '@hooks/usePeacockAcl';
import { useBootup } from '@hooks/useBootup';
import { useCancerDetectUser } from '@hooks/useCancerDetectUser';
import { useShowFormulaRecs } from '@hooks/useShowFormulaRecs';

const ACL_ADMIN_URL = `${environment.PEACOCK_EXT_URL}/acl-admin.html`;

const renderedBottomNavRoutes = (
  isCancerDetectUser: boolean,
  cancerDetectClicked: boolean,
  showFormulaRecs: boolean,
) => {
  const filteredRoutes = (
    isCancerDetectUser || cancerDetectClicked
      ? DASHBOARD_ROUTES.filter((route) => !route.hideIconForCancerDetect)
      : DASHBOARD_ROUTES
  ).filter((route) => showFormulaRecs || !route.hideIconForDisabledFormulaRecs);

  return filteredRoutes.map((route) => (
    <li key={route.label} className="flex-1">
      <BottomNavItem asChild>
        <DashboardLayoutNavItem
          to={route.to}
          icon={route.icon}
          label={route.label}
          activeIcon={route.activeIcon}
          className="[&_span]:typography-footnote"
        />
      </BottomNavItem>
    </li>
  ));
};

export const DashboardLayoutBottomNavBar = () => {
  const { admin: isAdmin } = usePeacockAcl();
  const { bootupState } = useBootup();
  const { isCancerDetectClicked } = useCancerDetectUser();
  const showFormulaRecs = useShowFormulaRecs();
  const { kitDetailsData, CDkitDetailsData } = bootupState || {};
  const hideNavOptionsForCancerDetectUsers = Boolean(
    CDkitDetailsData && !kitDetailsData,
  );

  return (
    <BottomNavBar className="fixed bottom-0 md:hidden w-full">
      <ul className="w-full flex flex-row justify-between items-center px-4">
        {renderedBottomNavRoutes(
          hideNavOptionsForCancerDetectUsers,
          isCancerDetectClicked,
          showFormulaRecs,
        )}
        {isAdmin && (
          <li className="flex-1">
            <BottomNavItem asChild>
              <DashboardLayoutNavItem
                to={ACL_ADMIN_URL}
                external
                icon={Shield}
                activeIcon={Shield}
                label="Admin"
                className="[&_span]:typography-footnote"
              />
            </BottomNavItem>
          </li>
        )}
      </ul>
    </BottomNavBar>
  );
};
